import React, { Component } from 'react'
import { Col, Form, Input, Row, Select } from 'antd'
import InputNumber from 'rc-input-number'
import _ from 'lodash'

import 'antd/lib/input-number/style/css'
import './BackgroundInformationForm.scss'

const FormItem = Form.Item
const { Option } = Select


export class BackgroundInformationForm extends Component {
    render() {
        const { isNewProject, backgroundInformation, onInputChange, onInputValueChange } = this.props
        const { code, name, type, category, size, client_name, company_name, client_number, client_email, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address } = backgroundInformation

        return (
            <Form className="BackgroundInformationForm" layout="inline">
            	<Row>
	            	<Col span={12}>
	            		<Row>
			        		<FormItem label="Category">
		                        <Select 
		                        	showSearch
		                        	placeholder="Category" 
		                        	dropdownMatchSelectWidth={false} 
		                        	value={category}
		                        	onChange={onInputValueChange.bind(this, 'category')}
		                        	filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
		                        	disabled={!isNewProject}
		                        >
		                            <Option value="RE">RE</Option>
		                            <Option value="OF">OF</Option>
		                            <Option value="MI">MI</Option>
		                        </Select>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Type">
		                        <Select 
		                        	showSearch
		                        	placeholder="Type" 
		                        	dropdownMatchSelectWidth={false} 
		                        	value={type} 
		                        	onChange={onInputValueChange.bind(this, 'type')}
		                        	filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
		                        >
		                            <Option value="Apartment">Apartment</Option>
		                            <Option value="House">House</Option>
		                            <Option value="Subdivided Flat">Subdivided Flat</Option>
		                            <Option value="Shop">Shop</Option>
		                            <Option value="NGO">NGO</Option>
		                            <Option value="Restaurant">Restaurant</Option>
		                            <Option value="Elderly House">Elderly House</Option>
	                                <Option value="School">School</Option>
	                                <Option value="Office">Office</Option>
		                        </Select>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Size">
					        	<InputNumber
	                                prefixCls="ant-input-number"
	                                formatter={value => `${value} ft²`} 
	                                parser={string => string.replace(/[^\d]/g, '')} 
					        		value={size}
					        		min={0}
					        		onChange={onInputValueChange.bind(this, 'size')}
					        	/>
					        </FormItem>
				        </Row>
			    		<Row>
			        		<FormItem label="Flat">
	            				<Input 
	            					style={{width: 42}}
	            					value={flat}
					        		onChange={onInputChange.bind(this, 'flat')}
	            					addonBefore="Flat"
	            				/>
					        </FormItem>
					    </Row>
					    <Row>
			        		<FormItem label="Floor">
	            				<Input 
	            					style={{width: 43}}
	            					value={floor}
					        		onChange={onInputChange.bind(this, 'floor')}
	            					addonAfter="/F"
	            				/>
					        </FormItem>
			    		</Row>
			    		<Row>
			        		<FormItem label="Estate Name">
	            				<Input
	            					value={estate_name}
					        		onChange={onInputChange.bind(this, 'estate_name')}
	            				/>
					        </FormItem>
		        		</Row>
				        <Row>
			        		<FormItem label="Location">
	            				<Input
	            					value={site_location}
					        		onChange={onInputChange.bind(this, 'site_location')}
	            				/>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Site Address">
	            				<Input
	            					style={{width: 250}}
	            					value={site_address}
					        		onChange={onInputChange.bind(this, 'site_address')}
	            				/>
					        </FormItem>
				        </Row>
			        </Col>
	            	<Col span={12}>
	            		<Row>
	            			<FormItem label="Project Code">
	            				<span className="ant-form-text">{code}</span>
	            			</FormItem>
	            		</Row>
			    		<Row>
			        		<FormItem label="Project Name">
	            				<Input 
	            					value={name}
					        		onChange={onInputChange.bind(this, 'name')}
	            				/>
					        </FormItem>
					    </Row>
	            		<Row>
			        		<FormItem label="Company Name">
					        	<Input 
					        		value={company_name}
					        		onChange={onInputChange.bind(this, 'company_name')}
					        	/>
					        </FormItem>
				        </Row>
	            		<Row>
			        		<FormItem label="Client Name">
					        	<Input
					        		value={client_name}
					        		onChange={onInputChange.bind(this, 'client_name')}
					        	/>
					        </FormItem>
	            		</Row>
				        <Row>
			        		<FormItem label="Client Number">
	            				<Input
	            					value={client_number}
					        		onChange={onInputChange.bind(this, 'client_number')}
	            					addonBefore="+852"
	            				/>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Client Email">
						        <Input 
						        	value={client_email}
					        		onChange={onInputChange.bind(this, 'client_email')}
						        />
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Handled By (Name)">
						        <Input 
						        	value={handled_by_name}
					        		onChange={onInputChange.bind(this, 'handled_by_name')}
						        />
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Handled By (Number)">
	            				<Input
	            					value={handled_by_number}
					        		onChange={onInputChange.bind(this, 'handled_by_number')}
	            					addonBefore="+852"
	            				/>
					        </FormItem>
				        </Row>
			        </Col>
		        </Row>
        	</Form>
        )
    }
}

			        		// <FormItem label="Contact Person">
		           //              <Select 
		           //              	showSearch
		           //              	placeholder="Assign a Member" 
		           //              	dropdownMatchSelectWidth={false} 
		           //              	value={memberList.length !== 0 ? contact_person : undefined} 
		           //              	onChange={onInputValueChange.bind(this, 'contact_person')}
		           //              	filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
		           //              	disabled={!isAuthorized}
		           //              >
		           //              	{
		           //              		_.map(memberList, (member, idx) => {
		           //              			return <Option key={member._id} value={member._id}>{member.first_name} {member.last_name} ({member.contact_number})</Option>
		           //              		})
		           //              	}
		           //              </Select>
					        // </FormItem>
export default BackgroundInformationForm



// WEBPACK FOOTER //
// ./src/Commons/BackgroundInformationForm/BackgroundInformationForm.js